// Demo Data adapter — loads the bundled sample rides from static/data/demo.json.
// Selecting this source replaces any existing rides with demo data (handled by settings.js).

import { getMeta } from '../db.js';
import { reportError } from '../telemetry.js';

// Shared demo fetch — used by the settings button below and by the first-run
// auto-load in app.js. Returns an ingest batch: { rides, message }.
export async function loadDemoRides() {
    const response = await fetch('data/demo.json');
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const json = await response.json();
    return { rides: json.tours, message: `Loaded ${json.tours.length} demo rides.` };
}

const demoDataAdapter = {
    id: 'demo-data',
    name: 'Demo Data',
    kind: 'oneShot',
    description: 'Load a set of sample rides to explore all dashboard features. Replaces existing data.',
    infoText: 'Load a curated set of sample rides so you can explore every chart and feature without connecting a real data source. Replaces all existing data.',

    async renderConfig(container, onComplete) {
        const lastOp = await getMeta('lastOp_demo-data');
        const statusText = lastOp
            ? `${lastOp.message} · ${new Date(lastOp.timestamp).toLocaleString()}`
            : '';

        container.innerHTML = `
            <button id="btn-adapter-load-demo" class="btn-brut btn-brut--primary">
                Load demo data
            </button>
            <div id="demo-adapter-result" class="hint"></div>
            <div class="adapter-status" aria-live="polite">${statusText}</div>
        `;

        container.querySelector('#btn-adapter-load-demo')?.addEventListener('click', async () => {
            const resultEl = container.querySelector('#demo-adapter-result');
            resultEl.className = 'hint';
            resultEl.textContent = 'Loading…';
            try {
                const batch = await loadDemoRides();
                resultEl.className = 'hint hint--success';
                resultEl.textContent = batch.message;
                onComplete(batch);
            } catch (e) {
                reportError(e, { adapter: 'demo-data', op: 'fetch' });
                resultEl.className = 'hint hint--error';
                resultEl.textContent = `Failed to load demo data: ${e.message}`;
            }
        });
    },

    cleanup() {},
};

export default demoDataAdapter;
